import React, { Component } from "react";
import { connect } from "react-redux";

import { Apply_Promo } from "../../store/actions";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ItemsCarousel from "react-items-carousel";
import PromoItem from "./PromoItem";
export class index extends Component {
  state = {
    activeItemIndex: 0,
  };

  componentDidMount() {
    this.startAutoScroll();
  }

  componentWillUnmount() {
    this.stopAutoScroll();
  }

  startAutoScroll = () => {
    if (!this.props.settings.auto_scroll_promos) return;
    if (!this.intervalAutoScroll) {
      this.intervalAutoScroll = setInterval(this.scrollPromo, 5000);
    }
  };
  stopAutoScroll = (fromTouch = false) => {
    if (!this.props.settings.auto_scroll_promos) return;
    if (this.intervalAutoScroll) {
      clearInterval(this.intervalAutoScroll);
      this.intervalAutoScroll = null;
    }
    if (fromTouch) {
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout);
      }
      this.idleTimeout = setTimeout(this.startAutoScroll, 10000);
    }
  };

  scrollPromo = () => {
    const { coupons, promotions } = this.props; // or state
    const length =
      coupons.length +
      promotions.filter(
        (promo) =>
          !promo.hide_promotion &&
          (promo.remaining ||
            this.props.applied_promos.find((p) => p.id === promo.id))
      ).length;

    this.setState((prev) => ({
      activeItemIndex: (prev.activeItemIndex + 1) % length,
    }));
  };
  render() {
    let Coupons_List = [];
    Coupons_List = this.props.coupons.map((promo) => (
      <PromoItem promo={promo} is_coupon={true} key={"coupon " + promo.code} />
    ));
    let Promo_List = [];
    if (this.props.promotions && this.props.promotions.length) {
      this.props.promotions.forEach((promo) => {
        if (
          !promo.hide_promotion &&
          (promo.remaining ||
            this.props.applied_promos.find((p) => p.id === promo.id))
        ) {
          Promo_List.push(
            <PromoItem
              promo={promo}
              is_coupon={false}
              key={"promotion " + promo.id + " " + promo.name}
            />
          );
        }
      });
    }
    const chevronWidth = 20;
    return (
      <div
        className={`${
          Coupons_List.length + Promo_List.length > 1 ? "px-4" : "px-0"
        }`}
        style={{
          padding: `0px  0px`,
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
        onMouseEnter={this.stopAutoScroll}
        onTouchStart={() => this.stopAutoScroll(true)}
        onMouseLeave={this.startAutoScroll}
      >
        <ItemsCarousel
          numberOfCards={1}
          gutter={20}
          disableSwipe={
            Promo_List.length + Coupons_List.length <= 1 ? true : false
          }
          requestToChangeActive={(e) => this.setState({ activeItemIndex: e })}
          activeItemIndex={this.state.activeItemIndex}
          leftChevron={
            <ArrowBackIosIcon className="ml-2" width={chevronWidth} />
          }
          rightChevron={
            <ArrowForwardIosIcon className="" width={chevronWidth} />
          }
          outsideChevron
          chevronWidth={chevronWidth}
        >
          {Promo_List.concat(Coupons_List)}
        </ItemsCarousel>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    coupons: state.store.store.promos,
    promotions: state.store.store.smart_promos,
    applied_promos: state.cart.smart_promos,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
